import { DaisyDates } from "../types/daisydates";
import { responseHero } from "../utils/axiosInterceptor";

export const getDatesForDaisy = (): Promise<DaisyDates> => {
    return new Promise<DaisyDates>((resolve, reject) => {
        responseHero.get(`${process.env.REACT_APP_API_URL}/daisyclosuredate`).then((response) => {
            resolve(response.data as DaisyDates);
        })
        .catch(error => {
            console.error(error);
            reject(error);
        });
    });
};